import { NgModule } from '@angular/core';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { CityDefinedDialogComponent } from './city-defined-dialog.component';

@NgModule({
  declarations: [CityDefinedDialogComponent],
  imports: [SdvorButtonComponent],
  exports: [CityDefinedDialogComponent],
})
export class CityDefinedDialogModule {}
